/* eslint-disable no-console,func-names,react/no-multi-comp */
import React, { ReactElement, useState } from 'react';
import ReactDragListView from 'react-drag-listview';
import styled from 'styled-components';
import { Icon } from '../Icon';

interface ListProps {
  title?: string | ReactElement;
  id: string;
}

interface DraggableListProps {
  data: ListProps[];
}

export const DraggableList = ({ data }: DraggableListProps) => {
  const [listData, setListData] = useState(data);
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const updatedData = [...listData];
      const item = updatedData.splice(fromIndex, 1)[0];
      updatedData.splice(toIndex, 0, item);
      setListData(updatedData);
    },
    nodeSelector: 'li',
    handleSelector: 'svg',
  };

  return (
    <div>
      <ReactDragListView {...dragProps}>
        <List>
          {listData.map(({ title = '', id }) => (
            <ListItem key={id}>
              <DragIcon name="drag" size="small2" />
              {title}
            </ListItem>
          ))}
        </List>
      </ReactDragListView>
    </div>
  );
};

const List = styled.ol`
  list-style-type: none;
`;

const ListItem = styled.li`
  padding: 16px;
  position: relative;
  transition: all ease 0.3s;
  display: flex;
  align-items: center;
  &:hover {
    box-shadow: 0 0.5em 1em ${({ theme }) => theme?.colors?.borderLightgray};
  }
`;

const DragIcon = styled(Icon)`
  padding: 0 20px;
  cursor: pointer;
  line-height: 0.8em;
`;
